// extracted by mini-css-extract-plugin
module.exports = {"message":"message--7ad11","messageText":"messageText--a4dc4"};